module.exports = __webpack_public_path__ + "static/img/download.a2877fa8.svg";